import React, { useEffect, useState } from "react";
import { Container } from "reactstrap";
import NoInternetComp from "../../components/common/InternetConnetction/NoInternetComp";
import { useNavigate } from "react-router-dom";
import { getServices } from "../../apiServices/apiServices";
import toast from "react-hot-toast";
import config from "../../config.json";
import LoadingSpinner from "../../components/common/Admin/common/LoadingSpinner";
import moment from "moment";

function BlogPage() {
  const [insightsData, setInsightsData] = useState([]);
  const [isLoading, setIsLoading] = useState(false);
  const navigate = useNavigate();
  const baseurl = config.url;

  useEffect(() => {
    fetchInsightsList();

    window.scrollTo(0, 0);
  }, []);

  const fetchInsightsList = async () => {
    setIsLoading(true);

    try {
      const res = await getServices(`/api/blog/list`);
      setIsLoading(false);

      if (res.responseCode === 200) {
        setInsightsData(res.responseData);
      } else {
        setInsightsData([]);
      }
    } catch (error) {
      setIsLoading(false);
      toast.error(error);
    }
  };

  return (
    <>
      <Container className="pt-2">
        {navigator.onLine ? (
          <Container>
            {/* {access_token ? ( */}
            <Container>
              {isLoading ? (
                <Container className="flex justify-center items-center min-h-[65vh]">
                  <LoadingSpinner />
                </Container>
              ) : (
                <Container className="min-h-[65vh]">
                  {insightsData.length <= 0 ? (
                    <Container className="flex justify-center items-center h-[65vh]">
                      <p className="font-semibold text-lg">
                        No insights found...
                      </p>
                    </Container>
                  ) : (
                    <Container className="max-w-7xl w-full mx-auto">
                      <Container className="mx-4 sm:mx-8 gap-6 mb-10 grid grid-cols-1 sm:grid-cols-2 lg:grid-cols-3">
                        {insightsData.map((blog, index) => (
                          <Container
                            key={index}
                            className="shadow-lg rounded-2xl p-4 hover:shadow-2xl transition-shadow duration-300 cursor-pointer"
                            onClick={() =>
                              navigate("/insight/detail", { state: { blog } })
                            }
                          >
                            <img
                              src={baseurl + blog.image}
                              alt="Solmelu Blog"
                              className="h-48 w-full object-cover rounded-2xl mb-4"
                            />
                            <p className="text-right mb-1 text-gray-500 text-sm">
                              {blog.createdAt
                                ? moment(blog.createdAt).format("ll")
                                : ""}
                            </p>
                            <Container className="font-semibold text-lg mb-2">
                              {blog.title}
                            </Container>
                            <Container className="text-sm text-gray-600 mb-4">
                              <div
                                className="prose prose-gray max-w-none"
                                dangerouslySetInnerHTML={{
                                  __html:
                                    blog.description.split(" ").length > 12
                                      ? blog.description
                                          .split(" ")
                                          .slice(0, 12)
                                          .join(" ") + "..."
                                      : blog.description,
                                }}
                              />
                            </Container>
                          </Container>
                        ))}
                      </Container>
                    </Container>
                  )}
                </Container>
              )}
            </Container>
            {/* ) : (
              <Container className="flex justify-center items-center h-[65vh] flex-col">
                <p className="font-semibold mb-4">Please login to continue.</p>
                <Link to="/login">
                  <Button className="bg-[#800000] font-semibold text-white py-2 px-10 rounded active:scale-[.98] active:duration-75 transition-all hover:scale-[1.01] ease-in-out">
                    Login
                  </Button>
                </Link>
              </Container>
            )} */}
          </Container>
        ) : (
          <Container className="min-h-[65vh] flex flex-col justify-center items-center">
            <NoInternetComp />
          </Container>
        )}
      </Container>
    </>
  );
}

export default BlogPage;
